// @flow
import { Button, Text, TextBlock } from 'bench-internal-theme';
import { colors } from 'bench-style-constants';
import React, { Fragment } from 'react';
import styled from 'styled-components';

import FinancialPackageAnnualTasks from './FinancialPackageAnnualTasks';
import type { ClientDetails, YearlyData } from './types';

const FinancialPackageNotesHeaderLayout = styled.div`
  display: flex;
  justify-content: space-between;
  /* Matches the max-width of the notes grid */
  max-width: 1262px;
`;

const FinancialPackageNotesHeaderSubTitle = styled.div`
  padding-bottom: 4px;
`;

const FinancialPackageNotesSubheaderLayout = styled.div`
  padding-top: 20px;
  display: grid;
  grid-template-columns: 120px max-content;
  grid-template-rows: 20px;
`;

type FinancialPackageNotesHeaderProps = {
  areYearEndPackagesComplete: boolean,
  clientDetails: ClientDetails,
  uploadFinancialPackageNotes: () => void,
  fiscalYear: number,
  hashtagFiscalYearTag: string,
  onStatusChange: (string, string) => void,
  showNewYefStatuses: boolean,
  yearlyData: YearlyData,
};

const FinancialPackageNotesHeader = ({
  areYearEndPackagesComplete,
  clientDetails,
  fiscalYear,
  uploadFinancialPackageNotes,
  hashtagFiscalYearTag,
  onStatusChange,
  showNewYefStatuses,
  yearlyData,
}: FinancialPackageNotesHeaderProps) => (
  <Fragment>
    <FinancialPackageNotesHeaderLayout>
      <div>
        <TextBlock styleType="title">Financial Package Notes</TextBlock>
        <FinancialPackageNotesHeaderSubTitle>
          <Text color={colors.dust} styleType="mediumBold">
            Fiscal Year {fiscalYear},
          </Text>
          <Text color={colors.dust} styleType="mediumBold" uppercase>
            {hashtagFiscalYearTag}
          </Text>
        </FinancialPackageNotesHeaderSubTitle>
        <span
          title={
            areYearEndPackagesComplete
              ? ''
              : 'Creating a Financial Package is unavailable until the YER is complete and the YEF is complete or in review.'
          }
        >
          <Button
            onClick={uploadFinancialPackageNotes}
            disabled={!areYearEndPackagesComplete}
            styleType="primary"
          >
            Create Package In Folders
          </Button>
        </span>
      </div>
      <FinancialPackageAnnualTasks
        onStatusChange={onStatusChange}
        showNewYefStatuses={showNewYefStatuses}
        yearlyData={yearlyData}
      />
    </FinancialPackageNotesHeaderLayout>
    <FinancialPackageNotesSubheaderLayout>
      <Text color={colors.dust} styleType="small">
        Filing Type
      </Text>
      <Text color={colors.smoke} styleType="small">
        {clientDetails.structure || 'N/A'}
      </Text>
      <Text color={colors.dust} styleType="small">
        Industry
      </Text>
      <Text color={colors.smoke} styleType="small">
        {clientDetails.industry || 'N/A'}
      </Text>
    </FinancialPackageNotesSubheaderLayout>
  </Fragment>
);

export default FinancialPackageNotesHeader;
